import { numberRegex, NumberRegExError } from "./types";

export default function validateStringToNumber(item: string) {
  if (!item || !item.length) {
    return NumberRegExError.MISSING;
  }

  const numberRegexTester = new RegExp(numberRegex);

  const result = numberRegexTester.test(item);

  if (result && item.length > 20) {
    return NumberRegExError.MAX_LENGTH;
  }

  return result ? NumberRegExError.VALID : NumberRegExError.INVALID;
}
